import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { TextBone } from '../../atoms/TextBone/TextBone';
import { BoxBone } from '../../atoms/BoxBone/BoxBone';

interface FormSectionBoneProps {
    /** Nom de la section (affecte la hauteur) */
    sectionName?: string;
    /** Nombre total de sections */
    totalSections?: number;
    /** Afficher l'en-tête de section */
    showHeader?: boolean;
    /** Styles personnalisés */
    sx?: SxProps<Theme>;
}

export const FormSectionBone: React.FunctionComponent<FormSectionBoneProps> = function ({
    sectionName = 'section',
    totalSections = 1,
    showHeader = true,
    sx = {},
}) {
    const calculateHeight = () => {
        if (totalSections <= 1) return '200px';
        return `${(sectionName.length * 150) / totalSections}px`;
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 1,
                width: '100%',
                ...sx,
            }}
        >
            {showHeader && (
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: 1,
                    }}
                >
                    <TextBone sx={{ width: '20%', height: '48px' }} />
                    <TextBone sx={{ width: '10%', height: '32px' }} />
                </Box>
            )}
            <BoxBone
                sx={{
                    width: '100%',
                    height: calculateHeight(),
                }}
            />
        </Box>
    );
};
